import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { UsernameAlerts, Username } from "../../../../Constant";
import { USERNAME_ALERT } from "../../../../Data/Bonus Ui/SweetAlert";

const UsernameAlert = () => {
  const displayAlert = () => {
    SweetAlert.fire({ text: "Please! Submit Your Username :", input: "text", confirmButtonColor:"#33BFBF" }).then((result) => {
      if (result.value) {
        SweetAlert.fire({ text: `Your name is : ${result.value}`,confirmButtonColor:"#33BFBF" });
      } else {
        SweetAlert.fire({ text: `Your name is : ${result.value}`,confirmButtonColor:"#33BFBF" });
      }
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={UsernameAlerts} span={USERNAME_ALERT} />
        <CardBody className="btn-showcase">
          <Btn color="secondary" className="sweet-1" type="button" onClick={displayAlert}>
            {Username}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UsernameAlert;
